import { cssVar, defineStyle, defineStyleConfig } from '@chakra-ui/react';

const $startColor = cssVar('skeleton-start-color');
const $endColor = cssVar('skeleton-end-color');

const lightGray = defineStyle({
  _light: {
    [$startColor.variable]: 'colors.gray.100',
    [$endColor.variable]: 'colors.gray.200',
  },
});

export const Skeleton = defineStyleConfig({
  variants: {
    lightGray
  }
});